<template>
  <div class="opinions-box">
    <vueper-slides :fixed-height="true" :arrows="false" autoplay :pause-on-hover="true" v-if="!loadingOpinions">
      <vueper-slide v-for="(opinion, index) in opinions" :key="index">
        <template v-slot:content>
          <OpinionSlide :data="opinion"/>
        </template>
      </vueper-slide>

      <template v-slot:pause>
        <font-awesome-icon :icon="['far', 'pause-circle']" id="pause-icon"/>
      </template>
    </vueper-slides>
    <div class="loading-box" v-if="loadingOpinions">
      <Loader/>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
import OpinionSlide from './OpinionSlide'
import Loader from '../Loader'

export default {
  name: 'OpinionsBox',
  components: { VueperSlides, VueperSlide, OpinionSlide, Loader },
  data() {
    return {
      opinions: [],
      loadingOpinions: true
    }
  },
  methods: {
    loadOpinions() {
      axios({
        method: "POST",
        url: "https://graphql.datocms.com",
        headers: {
          Authorization: 'bearer ' + 'a80e7c69e34cfcc1afa81f28c89c42'
        },
        data: {
          query: `
            {
              allHomeOpinions {
                image {
                  url
                }
                name
                opinion
                profilePicture {
                  url
                }
              }
            }
          `
        }
      }).then(result => {
        this.opinions = result.data.data.allHomeOpinions;
        this.loadingOpinions = false;
      }).catch(err => {
        console.log(err);
        this.loadingOpinions = false;
      });
    }
  },
  mounted() {
    this.loadOpinions();
  }
}
</script>

<style lang="scss" scoped>
.opinions-box {
  width: 100%;
  height: 30rem;
  background-color: #006f6f;
  @media (max-width: 850px) {
    height: 52rem;
  }
  @media (max-width: 550px) {
    height: 48rem;
  }
  @media (max-width: 500px) {
    height: 45rem;
  }
}

.loading-box {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.vueperslides--fixed-height { 
  height: 30rem;
  @media (max-width: 850px) {
    height: 52rem;
  }
  @media (max-width: 550px) {
    height: 48rem;
  }
  @media (max-width: 500px) {
    height: 45rem;
  }
}

.vueperslides__bullet .default {
  background-color: red;
}

#pause-icon {
  color: #F4F4F4;
  font-size: 1.5rem;
}
</style>